import React from "react";
import DynamicViewTable from "./DynamicViewTable";
import Popup from "reactjs-popup";
import "./CrossingInward.css";
import {
  podStatementTableHeader,
  podStatementTableItems,
} from "../config/PodStatement.js";
import { podStatementApiConfig } from "../config/apiConfig.js";
import { dataObject, validate } from "../config/PodStatement.js";

import { groupInfo, popupInfo } from "../config/PodStatement.js";
import DatePicker from "react-datepicker";

import { useState, useEffect, useRef } from "react";
import Autosuggest from "react-autosuggest";
import "./AutoSuggest.css";
import useForm from "./useForm";
import { SERVER_URL, USE_OVERLAY } from "../config/config";
import LoadingOverlay from "react-loading-overlay";
import ReportExcel from "./ReportExcel.js";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';

const PodStatementForm = ({ sessionObject, setGlobalOverlay }) => {
  const location = useLocation();
  const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(false);
  const [emailForm, setEmailForm] = useState({
    receiver_email: "",
    cc_email: "",
    subject: "",
    body: "",
    attachments: null
  });
  const [emailStatus, setEmailStatus] = useState(null); 
  const [emailResponse, setEmailResponse] = useState(null);
  const [pendingPodPopupOpen, setPendingPodPopupOpen] = useState(false);
  const [pendingPodData, setPendingPodData] = useState([]);
  const [pendingLoader, setPendingLoader] = useState(false);
  const [overlayText, setOverlayText] = useState("");

  const [selectedBilties, setSelectedBilties] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [confirmAttachPopup, setConfirmAttachPopup] = useState(false);

  let variablesFromSession = {
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
  
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
  
    return [year, month, day].join("-");
  }

  // Function to generate XLS file as blob
  const generateXLSBlob = async (pageState) => {
    const wb = XLSX.utils.book_new();
    
    const companyName = sessionObject?.sessionVariables?.company_name || "RAJ CARRYING CARGO PVT LTD AHMEDABAD";
    const consignorName = pageState.consignor_name || "MARICO LIMITED";
    const statementDate = pageState.input_date ? formatDate(pageState.input_date) : formatDate(new Date());
    
    const wsData = [];
    
    wsData.push([companyName]);
    wsData.push([`Statement No: ${pageState.pod_statement_no || ''}`, '', '', `Date:${statementDate}`]);
    wsData.push(['Dear']);
    wsData.push(['Sir,']);
    wsData.push(['', 'Here with we are sending the list of G.C., till we receive acknowledgement']);
    wsData.push(['Sr No', 'Bilty No', 'Bilty Date', 'Consignee Name', 'Cases', 'Station To', 'Remarks']);
    
    if (pageState.pod_info_list && pageState.pod_info_list.length > 0) {
      pageState.pod_info_list.forEach((item, index) => {
        wsData.push([
          index + 1,
          item.bilty_no || '',
          item.bilty_date || '',
          item.consignee_name || '',
          item.no_of_package || '',
          item.station_to || '',
          ''
        ]);
      });
    }
    
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    
    ws['!cols'] = [
      { wch: 8 },
      { wch: 12 },
      { wch: 12 },
      { wch: 25 },
      { wch: 8 },
      { wch: 15 },
      { wch: 15 }
    ];
    
    if (!ws['!merges']) ws['!merges'] = [];
    ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } });
    
    const headerCells = ['A1', 'A2', 'A6', 'B6', 'C6', 'D6', 'E6', 'F6', 'G6'];
    headerCells.forEach(cell => {
      if (ws[cell]) {
        ws[cell].s = {
          font: { bold: true },
          alignment: { horizontal: 'center', vertical: 'center' }
        };
      }
    });
    
    const tableStartRow = 5;
    const tableEndRow = tableStartRow + (pageState.pod_info_list?.length || 0);
    
    for (let R = tableStartRow; R <= tableEndRow; R++) {
      for (let C = 0; C < 7; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellAddress]) ws[cellAddress] = { t: 's', v: '' };
        ws[cellAddress].s = {
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } }
          }
        };
      }
    }
    
    XLSX.utils.book_append_sheet(wb, ws, "POD Statement");
    
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary', cellStyles: true });
    
    const buf = new ArrayBuffer(wbout.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < wbout.length; i++) {
      view[i] = wbout.charCodeAt(i) & 0xFF;
    }
    
    return new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  };

  const generatePDFBlob = async (biltyIds) => {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), 300000);
    const startResp = await fetch(`${SERVER_URL}/report/download_pod_image_report_async`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(biltyIds),
      signal: controller.signal,
    });
    
    if (!startResp.ok) {
      throw new Error(`HTTP error! Status: ${startResp.status}`);
    }
    
    const { task_id } = await startResp.json();
    let status = "pending";
    let downloadUrl;

    while (status === "pending") {
      await new Promise(r => setTimeout(r, 5000));
      const statusResp = await fetch(`${SERVER_URL}/report/pod_task_status/${task_id}`, {
        signal: controller.signal,
      });
      if (!statusResp.ok) throw new Error("Failed to check task status");
      const statusData = await statusResp.json();
      status = statusData.status;
      if (status === "ready") downloadUrl = statusData.download_url;
      if (status === "error") throw new Error(statusData.detail || "PDF generation failed");
    }

    const blobResp = await fetch(`${SERVER_URL}${downloadUrl}`, { signal: controller.signal });
    if (!blobResp.ok) throw new Error("Failed to download PDF");
    return await blobResp.blob();
  };

  let currDate = new Date()
  
  const download_ref = React.useRef(null);

  const myForm = useForm(
    "PODSTATEMENT",
    validate,
    { ...dataObject, ...variablesFromSession },
    podStatementApiConfig
  );  

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  useEffect(() => {
    const defaultPodNo = location.state ?? "";
    if(defaultPodNo != "") {
        myForm.setPageStateByField("pod_statement_no", defaultPodNo);

        const fakeKey = { key: "Enter" }
        myForm.getPageOnKeyEnter(fakeKey, defaultPodNo);
    }
  }, []);

  const transporterFieldInfo = {
    label: "Consignor Name",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "consignor_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getConsignorSuggestions",
    url: SERVER_URL + "/consignor/",
    suggestionKeyword: "consignor_name",
    suggestionKeywordExtra: "consignor_gst",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "consignor_id",
    suggestionSchema: {
      consignor_name: "consignor_name",
      consignor_gst: "consignor_gst",
      consignor_id: "consignor_id",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
      Enter: "add",
    },
    idClearanceNeeded: "consignor_id",
    inputDataNeededInSuggestions: false,
    inputDataFilter: {
      pay_type: "same",
    },
  };

  const linkBilty = async (e) => {
    if (e.target.value == "" && e.key == "Enter") {
      return;
    }
    if (e.key == "Enter") {
        const fYear_fetch = JSON.parse(sessionStorage.getItem("financial_year_for_fetch")).financial_year_for_fetch;
      const url = SERVER_URL +"/pod/pod_statement"
      let response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          date_to: myForm.pageState.input_date,
          branch_id: myForm.pageState.created_from,
          consignor_id: myForm.pageState.consignor_id,
          fyear: fYear_fetch,
          companyId: myForm.pageState.company_id,
        }),
      });

      if (!response.ok) {
        myForm.setPageState({
          ...myForm.pageState,
          ["Bilty No"]: "Invalid Bilty",
        });
        return;
      }
      const temp_response = await response.json();
      if (temp_response.check_fail) {
        myForm.setPageState({
          ...myForm.pageState,
          ["Bilty No"]: "Not possible to add this bilty",
        });
        return;
      }

      let newState = {
        pod_info_list: temp_response.pod_info,
      };

      if(myForm.pageMode == "edit") {
          newState = {
              pod_info_list: [
                  ...myForm.pageState.pod_info_list,
                  ...temp_response.pod_info,
              ]
          }
      }

      myForm.setPageState({
        ...myForm.pageState,
        ...newState,
      });
    }
  };

  const checkVisibilityCondition = (fieldInfo) => {
    if (fieldInfo.name == "edit_button") {
      return (myForm.pageState.id != "");
    } else if (fieldInfo.name == "delete_button") {
      return false;
    } else if (
      fieldInfo.name == "cheque_no" &&
      myForm.pageState.payment_type == "1"
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleDelete = async () => {
    const url =
      SERVER_URL + "/pod_statement/?pod_statement_id=" + myForm.pageState.id
        + "&companyId=" + myForm.pageState.company_id 
        + "&fyear=" + myForm.pageState.fYear_get;
    
        const response = await fetch(url, { method: "DELETE" });
    if (!response.ok) {
      console.log("Not able to delete Bill");
      return;
    }
    const temp_response = await response.json();
    if (temp_response.is_deleted) {
      myForm.setPageState({ ...dataObject, ...variablesFromSession });
      myForm.setPageMode("write");
      window.location.reload();
      return;
    }
  };

  const checkDisabledCondition = (fieldInfo) => {
    if (fieldInfo.name == "consignor_gst") {
      return "disabled";
    } else if (fieldInfo.name == "net_amount") {
      return "disabled";
    } else if (fieldInfo.name == "total_amount") {
      return "disabled";
    } else if (myForm.pageMode == "view") {
      return "disabled";
    } else if (myForm.pageMode == "edit" && fieldInfo.name == "party_name") {
      return "disabled";
    } else if (myForm.pageMode == "edit" && fieldInfo.name == "input_date") {
      return "disabled";
    } else {
      return "";
    }
  };

  const deleteEntryFromTableCallback = (infoObject) => {
    let biltyObj = myForm.pageState.pod_info_list[infoObject.idx];
    let newState = {};
    let tran_freight = parseInt(myForm.pageState.transporter_freight) || 0;
    let our_freight = parseInt(myForm.pageState.our_freight) || 0;
    let to_pay = parseInt(myForm.pageState.to_pay) || 0;
    let paid = parseInt(myForm.pageState.paid) || 0;
    let pkgs = parseInt(myForm.pageState.pkgs) || 0;

    tran_freight -= parseInt(biltyObj.transporter_freight) || 0;
    our_freight -= parseInt(biltyObj.total_amount) || 0;
    if (biltyObj.pay_type == "1") {
      to_pay -= parseInt(biltyObj.transporter_freight) || 0;
    } else {
      paid -= parseInt(biltyObj.transporter_freight) || 0;
    }
    pkgs -= parseInt(biltyObj.no_of_package) || 0;

    newState.transporter_freight = String(tran_freight);
    newState.our_freight = String(our_freight);
    newState.pkgs = String(pkgs);
    newState.to_pay = String(to_pay);
    newState.paid = String(paid);
    newState.balance = String(our_freight - to_pay);
    newState.pod_info_list = infoObject.rows;

    myForm.setPageState({
      ...myForm.pageState,
      ...newState,
    });
  };

  const handleImageUpload = async (rowItem, idx) => {
    try {
      const biltyId = rowItem.bilty_id;

      let file = await new Promise((resolve) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = (event) => resolve(event.target.files[0]);
        input.click();
      });

      if (!file) {
        console.warn("No file selected");
        return;
      }

      setOverlayText("Uploading images...");
      myForm.setOverlay(true);

      const apiUrl = `${SERVER_URL}/pod_image?image_id=${biltyId}&type=bilty_pod&client_name=rcc`;

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(apiUrl, { method: "POST", body: formData });

      myForm.setOverlay(false);

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status}`);
      }

      let responseData = await response.json();

      if (responseData.status_code === 407) {
        alert("QR code not visible");
      } else if (responseData.status_code === 406) {
        alert("QR Code is mismatch");
      } else {
        alert("Image uploaded successfully");
      }
    } catch (err) {
      myForm.setOverlay(false);
      console.error("Error uploading POD:", err);
      alert("Failed to upload image. Please try again.");
    }
  };

  const handleDownloadPod = async (biltyIds) => {
    try {
      if (!biltyIds || !biltyIds.length) {
        throw new Error("No bilty IDs provided");
      }

      setOverlayText("Starting PDF generation...");
      myForm.setOverlay(true);

      const controller = new AbortController();
      setTimeout(() => controller.abort(), 300000);
      const startResp = await fetch(`${SERVER_URL}/report/download_pod_image_report_async`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(biltyIds),
        signal: controller.signal,
      });

      if (!startResp.ok) {
        throw new Error(`HTTP error! Status: ${startResp.status}`);
      }

      const { task_id } = await startResp.json();
      let status = "pending";
      let downloadUrl;

      while (status === "pending") {
        setOverlayText("Generating PDF...");
        await new Promise(r => setTimeout(r, 5000));
        const statusResp = await fetch(`${SERVER_URL}/report/pod_task_status/${task_id}`, {
          signal: controller.signal,
        });
        if (!statusResp.ok) throw new Error("Failed to check task status");
        const statusData = await statusResp.json();
        status = statusData.status;
        if (status === "ready") downloadUrl = statusData.download_url;
        if (status === "error") throw new Error(statusData.detail || "PDF generation failed");
      }

      setOverlayText("Downloading PDF...");
      const blobResp = await fetch(`${SERVER_URL}${downloadUrl}`, { signal: controller.signal });
      if (!blobResp.ok) throw new Error("Failed to download PDF");
      const blob = await blobResp.blob();
      const downloadLink = document.createElement("a");
      const blobUrl = URL.createObjectURL(blob);

      downloadLink.href = blobUrl;
      downloadLink.download = "pod_images.pdf";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      myForm.setOverlay(false);
    }
  };

  // Reset email form
  const resetEmailForm = () => {
    setEmailForm({
      receiver_email: "",
      cc_email: "",
      subject: "",
      body: "",
      attachments: null,
    });
    setEmailStatus(null);
    setEmailResponse(null);
  };

  const fetchPendingPOD = async () => {
    try {
      setPendingLoader(true);
      setOverlayText("Fetching pending POD...");
      myForm.setOverlay(true);

      const url = `${SERVER_URL}/pod/get_pending_bilty_for_statement`;

      const body = {
        date_to: myForm.pageState.input_date,
        branch_id: String(myForm.pageState.created_from),
        consignor_id: Number(myForm.pageState.consignor_id),
        fyear: sessionStorage.getItem("financial_year_for_fetch")
          ? JSON.parse(sessionStorage.getItem("financial_year_for_fetch")).financial_year_for_fetch
          : myForm.pageState.fYear,
        companyId: String(myForm.pageState.company_id),
        pod_statement_id: Number(myForm.pageState.id || 0),
      };

      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await resp.json();
      setPendingLoader(false);

      if (!resp.ok) {
        console.log("Failed to load Pending POD");
        myForm.setOverlay(false);
        return;
      }

      setPendingPodData(data.pod_info || null);

      setPendingPodPopupOpen(true);

      myForm.setOverlay(false);

    } catch (err) {
      setPendingLoader(false);
      myForm.setOverlay(false);
      console.error("Error fetching pending POD:", err);
    }
  };

  const handleAttachBilties = async () => {
    try {
      setOverlayText("Attaching selected bilties...");
      myForm.setOverlay(true);

      const apiUrl = `${SERVER_URL}/bilty/update_pod_statement_id`;

      const body = {
        bilty_id: selectedBilties,
        pod_statement_id: Number(pendingPodData?.pod_statement_id || 0),
      };

      const resp = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await resp.json();

      myForm.setOverlay(false);

      if (resp.ok && (data.flag === 1 || data.success)) {
        setGlobalOverlay({
          visible: true,
          status: "success",
          title: "Bilties Attached",
          message: `${selectedBilties.length} bilties were successfully attached to POD No. ${myForm.pageState.pod_statement_no}.`,
        });

        fetchPendingPOD();

        setSelectedBilties([]);
        setSelectAll(false);

        setPendingPodPopupOpen(false);

      } else {
        setGlobalOverlay({
          visible: true,
          status: "error",
          title: "Failed to Attach Bilties",
          message: data.message || "Something went wrong while attaching the bilties.",
        });
      }

    } catch (err) {
      myForm.setOverlay(false);

      console.error("Attach error:", err);

      setGlobalOverlay({
        visible: true,
        status: "error",
        title: "Error Occurred",
        message: "Unable to attach bilties. Please try again.",
      });
    }
  };

  return (
    <div className="mr-form-container">
      {USE_OVERLAY && (
        <LoadingOverlay
          active={myForm.overlay}
          spinner
          text={overlayText || "Loading..."}
          styles={{
            wrapper: { overflow: "hidden" }
          }}
        />
      )}
      <div>
        <Popup
          open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                {myForm.pageMode == "submitted" ? (
                  <div>{popupInfo.success_header}</div>
                ) : (
                  <div>{popupInfo.error_header}</div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode == "submitted" ? (
                <div className="pop-up-content">
                  {popupInfo.success_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_success}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.pageState[popupInfo.field_name_success]}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  
                  {popupInfo.error_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_error}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode == "submitted") {
                      myForm.setPageState({
                        ...dataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      myForm.setPageMode("write");
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div>
        <Popup
          open={myForm.deletePopup}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">Are you sure want to delete?</div>
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    handleDelete();
                    myForm.setDeletePopup(false);
                    close();
                  }}
                >
                  Yes
                </button>
                <button
                  className="pop-up-button"
                  onClick={() => {
                    myForm.setDeletePopup(false);
                    close();
                  }}
                >
                  No
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div>
        <Popup
          open={isEmailPopupOpen}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => {
            const [errors, setErrors] = useState({});

            const handleSend = async () => {
              const newErrors = {};
              if (!emailForm.receiver_email)
                newErrors.receiver_email = "Receiver Email is required";
              if (!emailForm.subject) newErrors.subject = "Subject is required";
              if (!emailForm.body) newErrors.body = "Body is required";

              setErrors(newErrors);
              if (Object.keys(newErrors).length > 0) return;

              // Set status to processing immediately
              setEmailStatus("processing");
              setEmailResponse("Preparing files and sending email...");

              // Start the async process
              (async () => {
                try {
                  const formData = new FormData();
                  
                  // Auto-generate and attach XLS file
                  try {
                    setEmailResponse("Generating Excel file...");
                    const xlsBlob = await generateXLSBlob(myForm.pageState);
                    const xlsFileName = `POD_Statement_${myForm.pageState.pod_statement_no || 'report'}_${formatDate(new Date())}.xlsx`;
                    formData.append("attachments", xlsBlob, xlsFileName);
                  } catch (xlsError) {
                    console.error("Error generating XLS:", xlsError);
                    setGlobalOverlay({
                      visible: true,
                      status: "error",
                      title: "Failed to Generate Excel",
                      message: "POD Statement: Failed to generate Excel file. Please try again.",
                    });
                    return;
                  }
                  
                  // Auto-generate and attach PDF file (if POD images are available)
                  if (myForm.pageState.pod_info_list?.length > 0 &&
                      myForm.pageState.pod_info_list.every((bilty) => bilty.is_pod_image === 1)) {
                    try {
                      setEmailResponse("Generating PDF file...");
                      const biltyIds = myForm.pageState.pod_info_list.map((bilty) => bilty.bilty_id);
                      const pdfBlob = await generatePDFBlob(biltyIds);
                      
                      // Check PDF size (20MB limit)
                      const pdfSizeMB = pdfBlob.size / (1024 * 1024);
                      if (pdfSizeMB > 20) {
                        setGlobalOverlay({
                          visible: true,
                          status: "error",
                          title: "PDF Size Exceeded",
                          message: `POD Statement: PDF file size (${pdfSizeMB.toFixed(2)} MB) exceeds 20 MB limit. Please manually attach a file below 20 MB.`,
                        });
                        return;
                      }
                      
                      const pdfFileName = `POD_Images_${myForm.pageState.pod_statement_no || 'report'}_${formatDate(new Date())}.pdf`;
                      formData.append("attachments", pdfBlob, pdfFileName);
                    } catch (pdfError) {
                      console.error("Error generating PDF:", pdfError);
                      setGlobalOverlay({
                        visible: true,
                        status: "error",
                        title: "Failed to Generate PDF",
                        message: `POD Statement: Failed to generate PDF - ${pdfError.message}`,
                      });
                      return;
                    }
                  }
                  
                  // Attach additional user-selected files
                  if (emailForm.attachments && emailForm.attachments.length > 0) {
                    Array.from(emailForm.attachments).forEach((file, index) => {
                      const safeName = file.name?.trim() || `attachment-${index + 1}.dat`;
                      formData.append("attachments", file, safeName);
                    });
                  }

                  setEmailResponse("Sending email...");
                  
                  const queryParams = new URLSearchParams({
                    receiver_email: emailForm.receiver_email,
                    cc_email: emailForm.cc_email || "",
                    subject: emailForm.subject,
                    body: emailForm.body,
                  }).toString();

                  const resp = await fetch(
                    `${SERVER_URL}/mail/send_yahoo_updated?${queryParams}`,
                    { method: "POST", body: formData }
                  );

                  const data = await resp.json();

                  if (data.flag === 1) {
                    setGlobalOverlay({
                      visible: true,
                      status: "success",
                      title: "Email Sent Successfully!",
                      message: `POD Statement email sent successfully! ${data.message || "Email sent with POD Statement files attached to " + emailForm.receiver_email}`,
                    });
                  } else {
                    setGlobalOverlay({
                      visible: true,
                      status: "error",
                      title: "Failed to Send POD Statement Email",
                      message: data.message && data.message.includes("Message size exceeds fixed maximum message size")
                        ? "POD Statement Email not sent: The attachments are too large. Please reduce the size and try again."
                        : `POD Statement: ${data.message || "Failed to send email"}`,
                    });
                  }
                } catch (err) {
                  console.error(err);
                  setGlobalOverlay({
                    visible: true,
                    status: "error",
                    title: "Error Occurred",
                    message: "POD Statement: Error sending email - " + err.message,
                  });
                }
              })();
            };

            return (
              <div className="pop-up-container">
                <div className="pop-up-header">
                  {emailStatus === "success"
                    ? "Email Sent Successfully"
                    : emailStatus === "error"
                    ? "Error Sending Email"
                    : emailStatus === "processing"
                    ? "Processing..."
                    : "Send Email"}
                  <div>
                    <a
                      className="pop-up-close btn"
                      onClick={() => {
                        setIsEmailPopupOpen(false);
                        if (emailStatus !== "processing") {
                          resetEmailForm();
                        }
                        close();
                      }}
                    >
                      &times;
                    </a>
                  </div>
                </div>

                {emailStatus === "processing" && (
                  <div className="pop-up-content" style={{ color: "blue", padding: "20px", textAlign: "center" }}>
                    <div style={{ marginBottom: "15px", fontSize: "16px" }}>
                      {emailResponse}
                    </div>
                    <div style={{ fontSize: "14px", color: "#666" }}>
                      You can close this popup and continue your work. We'll notify you when the email is sent.
                    </div>
                  </div>
                )}

                {emailStatus === null && (
                  <div className="popup-content">
                    <div className="pop-up-fields">
                      <div className="pop-up-field">
                        <label className="form-label">
                          Email <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="form-input"
                          type="email"
                          value={emailForm.receiver_email}
                          onChange={(e) => {
                            setEmailForm({ ...emailForm, receiver_email: e.target.value });
                            setErrors({ ...errors, receiver_email: "" });
                          }}
                        />
                        {errors.receiver_email && (
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.receiver_email}
                          </span>
                        )}
                      </div>

                      <div className="pop-up-field">
                        <label className="form-label">CC (Optional)</label>
                        <input
                          className="form-input"
                          type="email"
                          value={emailForm.cc_email || ""}
                          onChange={(e) =>
                            setEmailForm({ ...emailForm, cc_email: e.target.value })
                          }
                        />
                      </div>

                      <div className="pop-up-field">
                        <label className="form-label">
                          Subject <span style={{ color: "red" }}>*</span>
                        </label>
                        <textarea
                          className="form-input"
                          rows={2}
                          value={emailForm.subject}
                          onChange={(e) => {
                            setEmailForm({ ...emailForm, subject: e.target.value });
                            setErrors({ ...errors, subject: "" });
                          }}
                          style={{ height: "40px" }}
                        />
                        {errors.subject && (
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.subject}
                          </span>
                        )}
                      </div>

                      <div className="pop-up-field">
                        <label className="form-label">
                          Body <span style={{ color: "red" }}>*</span>
                        </label>
                        <textarea
                          className="form-input"
                          rows={8}
                          value={emailForm.body}
                          onChange={(e) => {
                            setEmailForm({ ...emailForm, body: e.target.value });
                            setErrors({ ...errors, body: "" });
                          }}
                          style={{ height: "100px" }}
                        />
                        {errors.body && (
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.body}
                          </span>
                        )}
                      </div>

                      <div className="pop-up-field">
                        <label className="form-label">
                          Attachments (Optional)
                          <span style={{ fontSize: "12px", color: "#666", display: "block", marginTop: "5px" }}>
                            {emailForm.attachments && emailForm.attachments.length > 0 
                              ? "Manual attachments selected - Auto-generation disabled"
                              : "If no files selected, POD Statement XLS and PDF will be auto-generated"}
                          </span>
                        </label>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                          <input
                            type="file"
                            multiple
                            onChange={(e) => {
                              setEmailForm({
                                ...emailForm,
                                attachments: e.target.files,
                              });
                            }}
                            style={{ padding: "5px" }}
                          />
                          {emailForm.attachments && emailForm.attachments.length > 0 && (
                            <div style={{ fontSize: "12px", color: "#0066cc" }}>
                              {emailForm.attachments.length} file(s) selected
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="pop-up-actions">
                  {emailStatus === null ? (
                    <>
                      <button
                        className="pop-up-button"
                        onClick={() => {
                          setIsEmailPopupOpen(false);
                          resetEmailForm();
                          close();
                        }}
                      >
                        Cancel
                      </button>

                      <button
                        className="pop-up-button"
                        onClick={handleSend}
                      >
                        Send
                      </button>
                    </>
                  ) : emailStatus === "processing" ? (
                    <button
                      className="pop-up-button"
                      onClick={() => {
                        setIsEmailPopupOpen(false);
                        resetEmailForm();
                        close();
                      }}
                    >
                      Okay
                    </button>
                  ) : (
                    <button
                      className="pop-up-button"
                      onClick={() => {
                        setIsEmailPopupOpen(false);
                        resetEmailForm();
                        close();
                      }}
                    >
                      Okay
                    </button>
                  )}
                </div>
              </div>
            );
          }}
        </Popup>
      </div>
      <div>
        <Popup
          open={pendingPodPopupOpen}
          modal
          contentStyle={{ maxWidth: "600px", width: "90%" }}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">

              <div className="pop-up-header">
                Pending POD Summary
                <div>
                  <a
                    className="pop-up-close btn"
                    onClick={() => {
                      setPendingPodPopupOpen(false);
                      close();
                    }}
                  >
                    &times;
                  </a>
                </div>
              </div>

              <div className="pop-up-content">

                {pendingLoader ? (
                  <div style={{ padding: 20, textAlign: "center" }}>Loading...</div>
                ) : !pendingPodData ? (
                  <div style={{ padding: 20 }}>No Pending POD Found.</div>
                ) : (
                  <div style={{ padding: "10px 20px" }}>

                    <div style={{ marginBottom: "10px", fontSize: "16px" }}>
                      <b>Total Pending:</b> {pendingPodData.total}
                    </div>

                    <div style={{ marginTop: "15px", fontSize: "16px" }}>
                      <b>Pending Bilty Nos:</b>

                      {(pendingPodData?.bilty_list || []).length > 0 && (
                        <div style={{ margin: "10px 0" }}>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectAll(checked);
                              setSelectedBilties(
                                checked ? pendingPodData.bilty_list.map((b) => b.bilty_id) : []
                              );
                            }}
                          />
                          <span style={{ marginLeft: "8px" }}>
                            {selectAll ? "Deselect All" : "Select All"}
                          </span>
                        </div>
                      )}

                      <div
                        style={{
                          marginTop: "8px",
                          padding: "10px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          maxHeight: "250px",
                          overflowY: "scroll",
                          background: "#f8f8f8"
                        }}
                      >

                        {(pendingPodData?.bilty_list || []).map((item, idx) => {
                          const isChecked = selectedBilties.includes(item.bilty_id);
                          return (
                            <div key={idx} style={{ padding: "4px 0", display: "flex", alignItems: "center" }}>
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  if (checked) {
                                    setSelectedBilties([...selectedBilties, item.bilty_id]);
                                  } else {
                                    setSelectedBilties(selectedBilties.filter(id => id !== item.bilty_id));
                                    setSelectAll(false);
                                  }
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>{item.bilty_no}</span>
                            </div>
                          );
                        })}

                      </div>
                    </div>

                  </div>
                )}

              </div>

              <div className="pop-up-actions" style={{ display: "flex", justifyContent: "space-between" }}>
  
                {selectedBilties.length > 0 && (
                  <button
                    className="pop-up-button"
                    onClick={() => setConfirmAttachPopup(true)}
                  >
                    Attach {selectedBilties.length} Selected Bilties to POD
                  </button>
                )}

                <button
                  className="pop-up-button"
                  onClick={() => {
                    setPendingPodPopupOpen(false);
                    close();
                  }}
                >
                  Close
                </button>
              </div>

            </div>
          )}
        </Popup>
      </div>

      <div>
        <Popup
          open={confirmAttachPopup}
          modal
          contentStyle={{ maxWidth: "400px", width: "90%" }}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                Confirm Attachment
                <div>
                  <a className="pop-up-close btn" onClick={close}>&times;</a>
                </div>
              </div>

              <div className="pop-up-content">
                Are you sure you want to attach <b>{selectedBilties.length}</b> bilty(ies)
                to POD Statement No: <b>{myForm.pageState.pod_statement_no}</b>?
              </div>

              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    handleAttachBilties();
                    close();
                  }}
                >
                  Yes
                </button>
                <button
                  className="pop-up-button"
                  onClick={() => {
                    setConfirmAttachPopup(false);
                    close();
                  }}
                >
                  No
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="form-header">POD Statement</div>
      <div className="form">
        <div className="form-title">
          <div className="form-row">
            <label className="form-label">POD Statement No:</label>
            <input
              id="size"
              className="form-input"
              type="text"
              name="pod_statement_no"
              placeholder=""
              value={myForm.pageState.pod_statement_no}
              onChange={myForm.handleChange}
              onBlur={() => {}}
              autoFocus={true}
              onKeyPress={(a) =>
                myForm.getPageOnKeyEnter(a, myForm.pageState.pod_statement_no)
              }
              ref={(a) =>
                myForm.storeInputReferenceForSelect(a, "pod_statement_no")
              }
              disabled={myForm.pageMode == "view" ? "disabled" : ""}
            />
            {myForm.internalValidationErrors["challan_no"] && (
              <p>{myForm.internalValidationErrors["challan_no"]}</p>
            )}
          </div>

          <div className="form-row">
          {myForm.pageMode == "view" && (
              <>
                {checkVisibilityCondition({ name: "edit_button" }) && (
                  <button
                    onClick={() => {
                      myForm.setPageMode("edit");
                    }}
                  >
                    Edit
                  </button>
                )}
                <button
                  onClick={() => {
                    myForm.setPageState({
                      ...dataObject,
                      ...variablesFromSession,
                    });
                    window.location.reload();
                    myForm.setPageMode("write");
                  }}
                >
                  Clear
                </button>
              </>
            )}
          </div>

          <div className="form-row">
            <label className="form-label">Consignor Name</label>
            { 
            myForm.pageMode == "edit" ? 
            <input
                type="text"
                name="consignor_name"
                value={myForm.pageState.consignor_name}
                onChange={myForm.handleChange}
                className="form-input"
                onKeyPress={linkBilty}
            />
            : <Autosuggest
              id={transporterFieldInfo["name"]}
              suggestions = {(myForm.suggestions != undefined) ? myForm.suggestions : ""}
              onSuggestionsFetchRequested={(a) =>
                myForm.onSuggestionsFetchRequested(a, (b) =>
                  myForm.suggestionFetchApi(transporterFieldInfo, b)
                )
              }
              onSuggestionsClearRequested={() =>
                myForm.onSuggestionsClearRequested(transporterFieldInfo)
              }
              getSuggestionValue={suggestion => suggestion[transporterFieldInfo.suggestionKeyword]}
              onSuggestionSelected={(a,b) =>
                myForm.getSuggestionValue(
                  b.suggestion,
                  transporterFieldInfo,
                  myForm.performSuggestions,
                  myForm.updatePageStateForGetSuggestion
                )
              }
              renderSuggestion={(a) =>
                myForm.renderSuggestion(a, transporterFieldInfo)
              }
              highlightFirstSuggestion ={true}
              ref={(a) => myForm.storeInputReference(a, false)}
              inputProps={{
                value: String(myForm.pageState[transporterFieldInfo["name"]]),
                onChange: (a, b) => {
                  myForm.onChangeAutoSuggest(a, b, transporterFieldInfo);
                },
                onBlur: () => {
                  transporterFieldInfo["toValidate"]
                    ? myForm.onblurValidator(transporterFieldInfo)
                    : {};
                },
                onKeyPress: linkBilty,
                disabled: checkDisabledCondition(transporterFieldInfo),
              }}
            />}
          </div>
          <div className="form-row">
            <label className="form-label">POD statement Date:{" "}</label>
            <DatePicker
            id="size"
            className="form-input"
              dateFormat="dd-MM-yyy"
              selected={myForm.pageState.input_date}
              onChange={(date) =>
                {return myForm.setPageStateByField("input_date", date)}
              }
              ref={(a) => myForm.storeInputReferenceForSelect(a, "bilty_date")}
              disabled={checkDisabledCondition({ name: "input_date" })}
              onKeyPress={(a) => {
                if (a.key == "Enter") {
                  myForm.makeFocusOnParticularFieldForItem("pod_statement_receive_date");
                }
              }}
            />
          </div>

          {(myForm.pageState.pod_statement_receive_date == "Invalid Date") ? 
          <div>
          <label className="form-label">POD Statement Received Date:{" "}</label>
          <DatePicker
          id="size"
          className="form-input"
            dateFormat="dd-MM-yyy"
            onChange={(date) => {
                  myForm.setPageStateByField("pod_receive_date_selected", "true");
                  myForm.setPageStateByField("pod_statement_receive_date", date);
              }
            }
            ref={(a) => myForm.storeInputReferenceForSelect(a, "pod_statement_receive_date")}
            onKeyPress={(a) => {
              if (a.key == "Enter") {
                myForm.makeFocusOnParticularFieldForItem(
                  "eway_bill_no",
                  0,
                  "eway_bill_no"
                );
              }
            }}
          />
          </div>

          : 

          <div className="form-row">
          <label className="form-label">POD Statement Received Date:{" "}</label>
            <DatePicker
            id="size"
            className="form-input"
              dateFormat="dd-MM-yyy"
              selected={
                myForm.pageState.pod_statement_receive_date}
              onChange={(date) => {
                    myForm.setPageStateByField("pod_receive_date_selected", "true");
                    myForm.setPageStateByField("pod_statement_receive_date", date);
                }
              }
              ref={(a) => myForm.storeInputReferenceForSelect(a, "pod_statement_receive_date")}
              onKeyPress={(a) => {
                if (a.key == "Enter") {
                  myForm.makeFocusOnParticularFieldForItem(
                    "eway_bill_no",
                    0,
                    "eway_bill_no"
                  );
                }
              }}
            />
          </div>
        }

          <div className="form-row">
            <label className="form-last_bilty">Last Statement No:</label>
            <label className="form-pod_statement">
              {myForm.pageState.last_consignor_bill_no}
            </label>
          </div>
          <div className="form-row" style={{ marginTop: "10px" }}>
            <button
              onClick={fetchPendingPOD}
              disabled={myForm.pageState.pod_info_list?.length === 0}
              className="btn btn-secondary"
              style={{
                padding: "6px 12px",
                backgroundColor: myForm.pageState.pod_info_list?.length === 0 ? "#ccc" : "#2f3654",
                cursor: "pointer",
                color: "white",
                border: "none",
                borderRadius: "4px",
                fontWeight: "bold"
              }}
            >
              Pending POD
            </button>
          </div>

        </div>

        <div className="table-container">
          <DynamicViewTable
            tableHeader={podStatementTableHeader}
            tableItems={podStatementTableItems}
            tableValues={myForm.pageState["pod_info_list"]}
            setPageStateByField={myForm.setPageStateByField}
            pageStateArray={myForm.pageState["pod_info_list"]}
            deleteEntryFromTableCallback={deleteEntryFromTableCallback}
            fieldMapping="pod_info_list"
            onUploadButtonClick={handleImageUpload}
          />
        </div>

        <div className="form-input-content-block-0">
          <div className="form-field-left">
            {groupInfo["group-1"].map(function (info) {
              if (info["type"] === "dropdown")
                return (
                  <div className={info["className"]} key={info["name"]}>
                    <label className={info["labelClassName"]}>
                      {info["label"]}
                    </label>

                    <select
                      className={info["inputClassName"]}
                      onChange={(newValue) => {
                        myForm.handleChangeForSelect(newValue, info["name"]);
                      }}
                      disabled={checkDisabledCondition(info)}
                      value={myForm.pageState[info["name"]]}
                      ref={(a) =>
                        myForm.storeInputReferenceForSelect(a, info["name"])
                      }
                      onKeyPress={(a) => myForm.onKeyPressForKeyNav(a, info)}
                    >
                      {info["dropdown_items"].map((dropdown_item) => (
                        <option
                          value={dropdown_item.value}
                          key={dropdown_item.label}
                        >
                          {dropdown_item.label}
                        </option>
                      ))}
                    </select>
                    {myForm.internalValidationErrors[info["name"]] && (
                      <p>{myForm.internalValidationErrors[info["name"]]}</p>
                    )}
                  </div>
                );
              else
                return (
                  <div className={info["className"]} key={info["name"]}>
                    {checkVisibilityCondition(info) && (
                      <label className={info["labelClassName"]}>
                        {info["label"]}
                      </label>
                    )}
                    {checkVisibilityCondition(info) && (
                      <Autosuggest
                        id={info["name"]}
                        suggestions = {(myForm.suggestions != undefined) ? myForm.suggestions : ""}
                        onSuggestionsFetchRequested={(a) =>
                          myForm.onSuggestionsFetchRequested(a, (b) =>
                            myForm.suggestionFetchApi(info, b)
                          )
                        }
                        onSuggestionsClearRequested={() =>
                          myForm.onSuggestionsClearRequested(info)
                        }
                        getSuggestionValue={suggestion => suggestion[info.suggestionKeyword]}
                        onSuggestionSelected={(a,b) =>
                          myForm.getSuggestionValue(
                            b.suggestion,
                            info,
                            myForm.performSuggestions,
                            myForm.updatePageStateForGetSuggestion
                          )
                        }
                        renderSuggestion={(a) =>
                          myForm.renderSuggestion(a, info)
                        }
                        highlightFirstSuggestion ={true}
                        ref={(a) => myForm.storeInputReference(a, false)}
                        inputProps={{
                          value: String(myForm.pageState[info["name"]]),
                          onChange: (a, b) => {
                            myForm.onChangeAutoSuggest(a, b, info);
                          },
                          onBlur: () => {
                            info["toValidate"]
                              ? myForm.onblurValidator(info)
                              : {};
                          },
                          onKeyPress: (a) =>
                            myForm.onKeyPressForKeyNav(a, info),
                          disabled: checkDisabledCondition(info),
                        }}
                      />
                    )}
                    {myForm.internalValidationErrors[info["name"]] && (
                      <p>{myForm.internalValidationErrors[info["name"]]}</p>
                    )}
                  </div>
                );
            })}
          </div>
        </div>

        <div className="form-footer">
          <button style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="bilty_report_excel"
              filename="tablexls"
              sheet="tablexls"
              buttonText="Download as XLS"
              ref={(a) => (download_ref.current = a)}
            />
          </button>
          <button
            className="download-table-xls-button"
            onClick={async () => {
              download_ref.current.handleDownload();
            }}
          >
            Download as XLS
          </button>
          {ReportExcel.excel_pod_data(
            myForm.pageState
          )}
          <button
            onClick={myForm.handleSubmit}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          <button onClick={()=>myForm.setDeletePopup(true)} className="btn btn-primary">Delete</button>
          <button
            onClick={() => {
              myForm.setPageState({
                ...dataObject,
                ...variablesFromSession,
              });
              window.location.reload();
              myForm.setPageMode("write");
            }}
            className="btn btn-primary"
          >
            New
          </button>
          {myForm.pageState.pod_info_list?.length > 0 &&
            myForm.pageState.pod_info_list.every((bilty) => bilty.is_pod_image === 1) && (
              <button
                onClick={() => {
                  const biltyIdsToDownload = myForm.pageState.pod_info_list.map(
                    (bilty) => bilty.bilty_id
                  );
                  handleDownloadPod(biltyIdsToDownload);
                }}
                className="btn btn-primary"
              >
                Download POD as PDF
              </button>
            )}
          {myForm.pageState.pod_info_list?.length > 0 && (
            <button onClick={() => setIsEmailPopupOpen(true)} className="btn btn-primary">
              Send Email
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PodStatementForm;
